import React, { useState } from 'react'
import WebsiteOverviewCard from './SettingsComponents/WebsiteOverviewCard'
import FavIconCard from './SettingsComponents/FavIconCard'
import ThemeColors from './SettingsComponents/ThemeColors'
import LegalConsent from './SettingsComponents/LegalConsent'
import CookieConsent from './SettingsComponents/CookieConsent'
import CustomCodeSection from './SettingsComponents/CustomCode'
import styled from 'styled-components'
import { useTheme } from '../../../middleware/ThemeContext'
import { Theme } from '../../../utils/themes'
import PreviewImage from '../../../assets/images/livePreview.png';
import { useGetSettingDetailsQuery } from '../../../api/pageBuilderApiSlice'
import SecLivePreview from '../SecLivePreview'
import { WebsiteFormValues } from '../../../types/types'
import WebsiteConfigPopup from '../WebsiteConfigPopup'
import LogoCard from './SettingsComponents/LogoCard'
import StyledText from '../../../components/StyledComponents/StyledText'
import FontPicker from '../components/FontPicker'

const Setting = ({ companyLoading, isResponsive, setSettingConfiguration, settingConfiguration, createdAt, updateAt, totalPages, customWebDomain }: { companyLoading?: boolean, isResponsive?: boolean, setSettingConfiguration: React.Dispatch<React.SetStateAction<WebsiteFormValues>>, settingConfiguration: WebsiteFormValues, createdAt: string, updateAt: string, totalPages: number, customWebDomain?: string | null }) => {
    const { theme } = useTheme();
    const [showConfigPopup, setShowConfigPopup] = useState({
        isOpen: false,
        isEdit: false
    });

    return (
        <div>
            <Container theme={theme} isResponsive={isResponsive}>
                <div className={`d-flex ${isResponsive ? 'gap-2' : 'gap-4'} justify-content-between`}>
                    <WebsiteOverviewCard
                        title={settingConfiguration?.websiteName}
                        domain={settingConfiguration?.websiteURl}
                        customWebDomain={customWebDomain}
                        createdDate={createdAt}
                        lastModified={updateAt}
                        totalPublished={totalPages}
                        isPublished={true}
                        onEdit={() => setShowConfigPopup({ isOpen: true, isEdit: true })}
                        onView={() => console.log('View clicked')}
                        isResponsive={isResponsive}
                        companyLoading={companyLoading}
                        statusId={settingConfiguration.statusId?.toString()}
                    />
                    {/* <img src={PreviewImage} width={"418px"} height={'auto'} alt='Live Preview' /> */}
                    <SecLivePreview websiteDetails={
                        {
                            websiteName: '',
                            websiteURl: '',
                            timezone: '',
                            logo: settingConfiguration?.logo ?? '',
                            active: false,
                            primaryColor: settingConfiguration?.primaryColor,
                            secondaryColor: settingConfiguration?.secondaryColor,
                            textColor: settingConfiguration?.textColor,
                            fontFamily: settingConfiguration?.fontFamily ?? 'Roboto',
                            logoPreview: settingConfiguration?.logoPreview ?? settingConfiguration?.logo ?? '',
                            loginDescription: '',
                            loginHeading: '',
                        }
                    } isResponsive={isResponsive} isSetting={true} />
                </div>

                <div className={`d-flex ${isResponsive ? 'gap-2' : ' gap-4'} justify-content-between mt-4`}>
                    <FavIconCard companyLoading={companyLoading} isResponsive={isResponsive} settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration} />
                    <LogoCard companyLoading={companyLoading} isResponsive={isResponsive} settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration} />
                </div>
            </Container>
            <div className='d-flex gap-2 justify-content-between mt-2'>
                <ThemeColors companyLoading={companyLoading} isResponsive={isResponsive} settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration} />
                <div className='p-3' style={{ border: `1px solid ${theme.CorporateTheme.colors.border}`, borderRadius: '10px', backgroundColor: theme.CorporateTheme.colors.background, width: '100%' }}>
                    <StyledText fontSize={isResponsive ? '16px' : '18px'} fontWeight={700} textColor={theme.CorporateTheme.colors.primary}>Choose Font Family</StyledText>

                    <div className='d-flex gap-3 mt-3'>
                        {['Times New Roman', 'Roboto', 'Montserrat', 'Poppins'].map((font) => (
                            <FontPicker
                                key={font}
                                inputName='fontFamily'
                                fontName={font}
                                selected={settingConfiguration.fontFamily === font}
                                onClick={() => setSettingConfiguration({ ...settingConfiguration, fontFamily: font })}
                                isResponsive={isResponsive}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className='d-flex gap-2 justify-content-between mt-2'>
                <LegalConsent companyLoading={companyLoading} isResponsive={isResponsive} settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration} />
                <CookieConsent companyLoading={companyLoading} isResponsive={isResponsive} settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration} />
            </div>
            <div className='mt-2'>
                <CustomCodeSection
                    companyLoading={companyLoading}
                    isResponsive={isResponsive}
                    headTagValue="<HEAD>\n  <meta name='viewport' content='width=device-width'>\n</HEAD>"
                    customCssValue="body { background: #f5f5f5; }"
                    customJsValue="// Your JS here\nconsole.log('Hello World');"
                    settingConfiguration={settingConfiguration} setSettingConfiguration={setSettingConfiguration}
                />
            </div>

            {showConfigPopup.isOpen && (
                <WebsiteConfigPopup isFromEdit={showConfigPopup.isEdit} setWebsiteDetails={setSettingConfiguration} websiteDetails={settingConfiguration} onClose={() => setShowConfigPopup({ isOpen: false, isEdit: false })} />
            )}

        </div>
    )
}

const Container = styled.div<{ theme: Theme, isResponsive?: boolean }>`
background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
padding: ${({ isResponsive }) => isResponsive ? '10px' : '20px'};
border-radius:10px;
border:1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
`
export default Setting
